export default "__VITE_ASSET__c76a0114__"